import React, { useState, ChangeEvent, Fragment } from "react";
import { Iconfont } from '@umu/umu-design';
import { classSet } from "@umu/umu-dom";
import './index.scss';

interface IProps {
    value: string;
    rows?: number;
    children?: JSX.Element;
    EditorInput?: JSX.Element;
    maxLength?: number;
    className?: string;
    isAllowEditor?: boolean;
    onChange: (val: string) => void
}
const MAX_INPUT_LENGTH = 16
const EditorInput = (props: IProps) => {
    const { value = '', isAllowEditor = false, maxLength = MAX_INPUT_LENGTH, rows = 1, children, className = '', onChange } = props;
    const [isEdit, setIsEdit] = useState(false);
    const onEditor = () => {
        setIsEdit(true)
    }
    const onInputValBlur = () => {
        setIsEdit(false)
    }
    const onInputValChange = (ev: ChangeEvent<HTMLTextAreaElement>) => {
        onChange(ev.currentTarget.value || '')
    }
    const renderTextZone = () => {
        return <textarea
            autoFocus
            style={{display: isEdit ? 'block' : 'none'}}
            className="certificate-content"
            defaultValue={value}
            rows={rows}
            onBlur={onInputValBlur}
            maxLength={maxLength}
            onChange={onInputValChange}
        />
    }
    const onContentText = () => {
        return value.length > maxLength ? `${value.slice(0, maxLength)}...` : value
    }
    return isAllowEditor ? <div className={`editor-panel-zone ${className}`}>

        <div className={classSet({
            'editor-text': true,
            'editor-icon-show': isAllowEditor,
            'editor-status-show': isEdit
        })}>
            {children}
            {isEdit ? renderTextZone() : <Fragment><div className='editor-panel-text'>{onContentText()}</div>
                <Iconfont type="Highlight" className="icon-editor" onClick={onEditor} /></Fragment>}
        </div>
    </div> : <span>{children}{onContentText()}</span>
}

export {
    EditorInput
}
